import { FC } from 'react'

const MatkahuoltoIcon: FC = () => (
  <svg
    width="89"
    height="20"
    viewBox="0 0 89 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_42823_863510)">
      <rect
        width="89"
        height="20"
        rx="5"
        fill="#0070B5"
      />
      <g clipPath="url(#clip1_42823_863510)">
        <path
          d="M87.6478 16.8094H1.10156V2.5H87.6478V16.8094Z"
          fill="#0070B5"
        />
        <path
          d="M44.3732 -9.29982C37.3173 -9.29982 31.1644 -5.44536 27.8996 0.270504H17.6211C21.494 -10.7716 32.0095 -18.6885 44.3759 -18.6885C56.7422 -18.6885 67.2578 -10.7716 71.1306 0.270504H60.8495C57.5821 -5.44799 51.4266 -9.29982 44.3732 -9.29982Z"
          fill="#0070B5"
        />
        <path
          d="M27.9023 19.042C31.167 24.7579 37.3199 28.6123 44.3759 28.6123C51.4318 28.6123 57.5848 24.7579 60.8495 19.042H71.1306C67.2578 30.0841 56.7423 38.001 44.3759 38.001C32.0121 38.001 21.4966 30.0841 17.6211 19.042H27.9023Z"
          fill="#0070B5"
        />
        <path
          d="M13.7077 6.19824V13.0515H12.2781V8.63624L10.2614 13.0515H9.30303L7.29681 8.65467V13.0515H5.86719V6.19824H7.65751L9.81116 10.9663L11.9648 6.19824H13.7077Z"
          fill="white"
        />
        <path
          d="M19.0703 6.19824L21.8216 13.0515H20.284L19.7074 11.5718H17.093L16.5164 13.0515H15.0078L17.7696 6.19824H19.0703ZM17.5432 10.3107H19.2651L18.3936 8.06755L17.5432 10.3107Z"
          fill="white"
        />
        <path
          d="M21.9453 6.19824H27.0372V7.56995H25.2337V13.0515H23.7567V7.56995H21.9453V6.19824Z"
          fill="white"
        />
        <path
          d="M30.1125 8.91006L32.4241 6.19824H34.1854L31.3657 9.42872L34.3803 13.0515H32.5294L30.4231 10.4187L30.1098 10.7715V13.0515H28.6328V6.19824H30.1098V8.91006H30.1125Z"
          fill="white"
        />
        <path
          d="M38.789 6.19824L41.5403 13.0515H40.0027L39.4262 11.5718H36.8118L36.2352 13.0515H34.7266L37.4884 6.19824H38.789ZM37.262 10.3107H38.9838L38.1124 8.06755L37.262 10.3107Z"
          fill="white"
        />
        <path
          d="M42.832 6.19824H44.3091V8.85213H47.0498V6.19824H48.5295V13.0515H47.0498V10.2607H44.3091V13.0515H42.832V6.19824Z"
          fill="white"
        />
        <path
          d="M50.582 10.3291V6.19824H52.0696V10.2528C52.0696 11.1743 52.5198 11.7509 53.3333 11.7509C54.1469 11.7509 54.5971 11.1743 54.5971 10.2528V6.19824H56.0846V10.3291C56.0846 12.0615 55.0473 13.1779 53.3333 13.1779C51.6194 13.1779 50.582 12.0615 50.582 10.3291Z"
          fill="white"
        />
        <path
          d="M61.1809 13.178C59.1932 13.178 57.5977 11.6009 57.5977 9.62365C57.5977 7.6464 59.1932 6.06934 61.1809 6.06934C63.1687 6.06934 64.7642 7.6464 64.7642 9.62365C64.7616 11.6035 63.1661 13.178 61.1809 13.178ZM61.1809 7.50159C60.0146 7.50159 59.1063 8.44151 59.1063 9.62629C59.1063 10.8111 60.0172 11.751 61.1809 11.751C62.3446 11.751 63.2556 10.8111 63.2556 9.62629C63.2556 8.44151 62.3446 7.50159 61.1809 7.50159Z"
          fill="white"
        />
        <path
          d="M67.8637 6.19824V11.6719H70.2516V13.0515H66.3945V6.19824H67.8637Z"
          fill="white"
        />
        <path
          d="M70.3672 6.19824H75.4591V7.56995H73.6582V13.0515H72.1786V7.56995H70.3672V6.19824Z"
          fill="white"
        />
        <path
          d="M79.9153 13.178C77.9275 13.178 76.332 11.6009 76.332 9.62365C76.332 7.6464 77.9275 6.06934 79.9153 6.06934C81.9031 6.06934 83.4986 7.6464 83.4986 9.62365C83.4986 11.6035 81.9031 13.178 79.9153 13.178ZM79.9153 7.50159C78.7516 7.50159 77.8406 8.44151 77.8406 9.62629C77.8406 10.8111 78.7516 11.751 79.9153 11.751C81.079 11.751 81.99 10.8111 81.99 9.62629C81.9926 8.44151 81.0817 7.50159 79.9153 7.50159Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_42823_863510">
        <rect
          width="89"
          height="20"
          rx="5"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_42823_863510">
        <rect
          width="86.5462"
          height="56.69"
          fill="white"
          transform="translate(1.08594 -18.6846)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default MatkahuoltoIcon
